import { Alert } from 'react-bootstrap';

import { hasError } from '../../../utils';
import { ErrorAlert } from '../../generic/ErrorAlert';
import RouterLink from '../../generic/Link/RouterLink';
import type { AuthContextState } from '../context/AuthContext';

const TEST_ID = 'auth-alert';

type FormAlertProps = Pick<AuthContextState, 'alert' | 'status'> & {
  email?: string;
};

/**
 * Displays any messages above the authentication form.
 */
const AuthFormAlert = ({ alert, status, email }: FormAlertProps) => {
  //  Display an error alert is there are status.errors
  // TODO(leo): Delete this and related helpers - boolean blindness occurring here.
  if (hasError(status)) {
    const stringifiedError = status.error.toString(); // stringify because this won't pass a deep equality check (since it's an `APIError` class).
    //  If the user was trying to register with an existing user, we display a link to the login page for them.
    if (stringifiedError === 'Username or email already taken by another user') {
      return (
        <Alert className="alert-error" data-test-id={TEST_ID}>
          {stringifiedError}{'. '}
          <RouterLink to={`/auth/login?email=${email}`}>
            Try logging in instead?
          </RouterLink>
        </Alert>
      );
    }

    return (
      <ErrorAlert
        status={status}
        testId={TEST_ID}
      />
    );
  }
  return !alert ? null : (
    <Alert kind="info" data-test-id={TEST_ID}>
      {alert}
    </Alert>
  );
};

export default AuthFormAlert;
